require('./green-card-by-investment.scss');
const {submitMailCta, sliderAction} = require("../utils");

$(() => {
    sliderAction();
    submitMailCta();
});